import React from 'react';
import { MarketBiddingVolumeChart } from './MarketBiddingVolumeChart';

interface MarketBiddingVolumeChartWrapperProps {
  startDate: string;
  endDate: string;
  isFullscreen?: boolean;
}

export function MarketBiddingVolumeChartWrapper({ startDate, endDate, isFullscreen = false }: MarketBiddingVolumeChartWrapperProps) {
  return (
    <div className={`text-left h-full w-full flex flex-col ${isFullscreen ? 'p-4' : ''}`}>
      <MarketBiddingVolumeChart 
        startDate={startDate}
        endDate={endDate}
        isFullscreen={isFullscreen}
      />
    </div>
  );
}
